import { configureStore } from '@reduxjs/toolkit';
import loginReducer from '../login/loginSlice';
import ordersReducer from '../orders/ordersSlice';
import sweepsReducer from '../sweeps/sweepsSlice';
import accCheckerReducer from '../accChecker/accCheckerSlice';
import docPanelLoadingReducer from '../loadingMonitor/loadingMonitorSlice';


export default configureStore({
  reducer: {
    login: loginReducer,
    orders: ordersReducer,
    sweeps: sweepsReducer,
    accChecker: accCheckerReducer,
    docPanelLoading: docPanelLoadingReducer,
  },
});
